import React from 'react';
import { ARIA_MESSAGE_TYPES } from '../ariaMessageTypes';
import AriaFirstContactOnboardingPreviewContent from './AriaFirstContactOnboardingPreviewContent';
import AriaPostEventCheckinCard from './AriaPostEventCheckinCard';

/** Routes inline Aria rich payloads rendered inside the message bubble. */
const AriaInlineRichMessageContent = ({ message, isOutbound = false, compact = false }) => {
  const type = message?.ariaMessageType;
  const payload = message?.ariaPayload;
  if (!type || !payload) return null;

  if (type === ARIA_MESSAGE_TYPES.POST_EVENT_CHECKIN) {
    return <AriaPostEventCheckinCard checkin={payload} isOutbound={isOutbound} compact={compact} />;
  }

  if (type === ARIA_MESSAGE_TYPES.ONBOARDING_PREVIEW) {
    return (
      <AriaFirstContactOnboardingPreviewContent
        preview={payload}
        isOutbound={isOutbound}
        compact={compact}
      />
    );
  }

  return null;
};

export default AriaInlineRichMessageContent;
